/**
 * バンドルリコメンデーションの対象として単一のバンドル設定情報が選び出される場合の、UI表示用パラメータ
 *
 * 将来的に、単一のバンドル設定情報が選び出される場合に、UI表示用パラメータが複数種類発生する場合は、種類ごとに適切なクラスを設けるなどして拡張すること。
 * 現時点では（パラメータの内容が変更されるとしても）1種類のパラメータで対応できる想定。
 */
export class SingleBundleRecommendationParameter {
  constructor(
    private readonly context: SingleInstanceContext | MultiInstanceContext,
    private readonly discount: BundleDiscount
  ) {}

  get bundleDiscountTitle(): string {
    return this.discount.title
  }

  get bundleDiscountUrl(): string {
    if (this.context instanceof SingleInstanceContext) {
      return `/bundle/${this.discount.campaignId}`
    }

    return `/${this.context.brand.englishName}/bundle/${this.discount.campaignId}`
  }
}

export interface Brand {
  englishName: string
}
export interface BundleDiscount {
  id: string  // パラメータ内では使用していないが、デバッグ目的でIDは付与しておく。
  title: string
  campaignId: string
}

export class Context {
  static asSingleInstance(): SingleInstanceContext {
    return new SingleInstanceContext()
  }

  static asMultiInstance(brand: Brand): MultiInstanceContext {
    return new MultiInstanceContext(brand)
  }
}
class SingleInstanceContext implements Context {}
class MultiInstanceContext implements Context {
  constructor(readonly brand: Brand) {}
}
